import { t } from 'i18n';
import React from 'react';
import slug from '@teko/slug';
import { styled, Button, Link, Currency } from '@teko/ui';
import { EmptyCartPanel, ProductCheckoutInfo } from '@teko/ecommerce';
import get from 'lodash.get';
import { useCart, PromotionAward } from '../contexts/CartContext';
const Wrapper = styled.div`
  background-color: #fff;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  width: 384px;
  max-height: 400px;
`;
const StyledButton = styled(Button)`
  padding: 0.7rem 1rem;
  text-decoration: none;
  &:hover {
    color: #fff;
  }
`;
const EmptyCartWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Footer = styled.div`
  padding: 0.5rem 0;
  border-top: 1px dashed #e0e0e0;
`;
const FooterLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 26px;
`;
const Body = styled.div`
  height: 260px;
  overflow-y: auto;
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 6px;
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #999;
  }
`;
const StyledEmptyCartPanel = styled(EmptyCartPanel)`
  width: 250px;
`;
const GrandTotal = styled.span`
  font-size: 18px;
  font-weight: 500;
`;
const ShippingFee = styled.span`
  font-size: 14px;
`;
export interface MiniCartProps {
  onHide?: () => void;
  disableProductPromo?: boolean;
  showShippingFee?: boolean;
}
export const MiniCart: React.FunctionComponent<MiniCartProps> = ({
  onHide,
  disableProductPromo,
  showShippingFee = true,
}: MiniCartProps) => {
  const cart = useCart();
  if (!cart.order || (cart.order && cart.order.orderLines.length === 0)) {
    return (
      <Wrapper>
        <EmptyCartWrapper>
          <StyledEmptyCartPanel />
        </EmptyCartWrapper>
      </Wrapper>
    );
  }
  //Cart shipping fee is deprecated
  const shippingFee = 0;
  return (
    <Wrapper>
      <Body>
        {cart.order.orderLines
          .filter((orderLine) => !orderLine.parentSku)
          .map((orderLine) => {
            const promotion = get(
              cart,
              ['order', 'promotionsMap', orderLine.lineItemId],
              {
                gifts: [],
              },
            ) as PromotionAward;
            return (
              <ProductCheckoutInfo
                mb={3}
                key={orderLine.lineItemId}
                imageUrl={
                  orderLine.product?.productInfo?.imageUrl ||
                  `/api/products/${orderLine.sku}/default_image`
                }
                name={orderLine.displayName || orderLine.name}
                price={orderLine.price}
                quantity={orderLine.quantity}
                disableProductPromo={disableProductPromo}
                targetPath={`/${slug(
                  orderLine.displayName || orderLine.name,
                )}-s${orderLine.sku}.html`}
                gifts={promotion.gifts.map((gift: any) => ({
                  name: `x${gift.quantity} ${gift.name}`,
                  imageUrl:
                    gift.imageUrl || `/api/products/${gift.sku}/default_image`,
                  isDefault: gift.isDefault,
                }))}
              />
            );
          })}
      </Body>
      <Footer>
        <FooterLine>
          <span>
            {t('Tổng tiền ({{totalCartItemsSelected}}) sản phẩm', {
              totalCartItemsSelected: cart.totalCartItemsSelected,
            })}
          </span>
          <GrandTotal>
            <Currency value={cart.subTotalAfterLineDiscount} />
          </GrandTotal>
        </FooterLine>
        {showShippingFee && shippingFee > 0 && (
          <FooterLine>
            <span>{t('Phí vận chuyển')}</span>
            <ShippingFee>
              <Currency value={shippingFee} />
            </ShippingFee>
          </FooterLine>
        )}
      </Footer>
      <Link href="/cart" as="/cart" passHref>
        <StyledButton
          variant="primary"
          block
          tag="a"
          onClick={onHide}
          data-track-content
          data-content-region-name="miniCart"
          data-content-name="viewCartFromMiniCart"
          data-content-target="shoppingCart"
        >
          {t('Xem giỏ hàng')}
        </StyledButton>
      </Link>
    </Wrapper>
  );
};
